import { PricingPlan } from '../types';

export const pricingPlans: PricingPlan[] = [
  {
    name: 'ESSAI GRATUIT',
    price: '0 FCFA',
    period: '',
    description: 'Découvrez XamXamBoutik sans risque',
    features: [
      '100 produits maximum',
      '1 utilisateur',
      'Durée : 1 mois',
      'Activé automatiquement à l\'inscription',
      'Ventes, caisse, dettes, retours',
      'Tableau de bord et statistiques',
      'Notifications en temps réel',
    ],
    cta: 'S\'inscrire gratuitement',
  },
  {
    name: 'STANDARD',
    price: '15 000 FCFA',
    period: '/mois',
    description: 'Pour les boutiques qui démarrent',
    features: [
      'Jusqu\'à 500 produits',
      'Jusqu\'à 3 utilisateurs',
      'Ventes en 30 secondes (scanner caméra + recherche)',
      'Multi-paiement (espèces, Orange Money, Wave)',
      'Gestion complète du stock & alertes',
      'Suivi des dettes clients avec historique',
      'Gestion des dépenses',
      'Retours & échanges (5 types)',
      'Approvisionnement (formulaire + import Excel)',
      '8 tableaux de bord en temps réel',
      'Gestion de caisse (ouverture/fermeture)',
      'Notifications en temps réel',
    ],
    cta: 'Commencer maintenant',
  },
  {
    name: 'PREMIUM',
    popular: true,
    price: '19 000 FCFA',
    period: '/mois',
    description: 'Pour les boutiques ambitieuses',
    features: [
      'Produits illimités',
      'Utilisateurs illimités',
      'Toutes les fonctionnalités sans restriction',
      'Ventes en 30 secondes (scanner caméra + recherche)',
      'Multi-paiement (espèces, Orange Money, Wave)',
      'Gestion complète du stock & alertes',
      'Suivi des dettes clients avec historique',
      'Gestion des dépenses',
      'Retours & échanges (5 types)',
      'Approvisionnement (formulaire + import Excel)',
      'Tableau de bord complet',
      'Gestion de caisse (ouverture/fermeture)',
      'Notifications en temps réel',
      'Envoi de factures par WhatsApp',
      'Support prioritaire',
      'Accompagnement personnalisé',
    ],
    cta: 'Commencer maintenant',
  },
];

// Formule : (prixMensuel × mois) - réduction
// Réductions : Trimestriel -800 | Semestriel -1 500 | Annuel -2 000
export const discountTiers = [
  { duration: 'Mensuel',      standard: '15 000',  premium: '19 000',  saving: null },
  { duration: 'Trimestriel',  standard: '44 200',  premium: '56 200',  saving: '800' },
  { duration: 'Semestriel',   standard: '88 500',  premium: '112 500', saving: '1 500' },
  { duration: 'Annuel',       standard: '178 000', premium: '226 000', saving: '2 000' },
];
